import { Grid } from '@material-ui/core';
import Divider from "../../common/divider";
import AboutUsInfo1 from "./aboutUsInfo1";
import AboutUsInfo2 from "./aboutUsInfo2";
import AboutUsInfo3 from "./aboutUsInfo3";
import AboutUsImage2 from "./aboutUsImage2";

import tacosImage from '../../common/images/food/tacos.jpeg';
import buildingSnowImage from '../../common/images/outside/building_snow_original.jpeg';

const AboutUsContainer = () => {
  return (
    <Grid container spacing={2} justify="center" style={{ marginTop: '30px', marginBottom: '50px' }}>
      <Grid item xs={11} md={3}>
        <AboutUsImage2 img={tacosImage} position="bottom" />
      </Grid>
      <Grid item sm={11} md={8}>
        <AboutUsInfo1 />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={11}>
        <AboutUsInfo2 />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={11} md={6}>
        <AboutUsInfo3 />
      </Grid>
      <Grid item xs={11} md={5}>
        <AboutUsImage2 img={buildingSnowImage} />
      </Grid>
    </Grid>
  );
};

export default AboutUsContainer;
